<div class="card">
  <div class="card-body">
    <spk-search-grid #grid list="RoleSearchRow" title="Roles" defaultSortProperty="Name" [leftLinks]="leftLinks" [csvExport]="true"></spk-search-grid>
  </div>
</div>